import * as THREE from 'three';
import { label } from './products';

// Original transparent artwork from Viewlux's public website, served locally.
export function addWallBranding(scene, renderer, onChange) {
  const canvas = renderer.domElement;
  const group = new THREE.Group();
  group.name = 'viewlux-back-wall-logo';
  group.position.set(0, 2.9, -8.72);
  scene.add(group);
  const width = 4.4;
  const fallback = label('VIEWLUX', width, 1.2, { color: '#d4af72', size: 130 });
  group.add(fallback);
  let disposed = false;
  canvas.dataset.wallBrand = 'viewlux';
  canvas.dataset.wallLogoState = 'loading';

  const texture = new THREE.TextureLoader().load('/branding/viewlux-logo.webp', image => {
    if (disposed) { image.dispose(); return; }
    image.colorSpace = THREE.SRGBColorSpace;
    image.anisotropy = Math.min(8, renderer.capabilities.getMaxAnisotropy());
    const height = width / (image.image.width / image.image.height);
    const geometry = new THREE.PlaneGeometry(height * image.image.width / image.image.height, height);
    const logo = new THREE.Mesh(geometry, new THREE.MeshBasicMaterial({
      map: image, transparent: true, depthWrite: false, toneMapped: false,
    }));
    logo.name = 'viewlux-original-artwork';
    // A slight dark offset suggests wall-mounted lettering without a plaque.
    const shadow = new THREE.Mesh(geometry, new THREE.MeshBasicMaterial({
      map: image, color: '#000000', transparent: true, opacity: .3, depthWrite: false,
    }));
    shadow.position.set(.014, -.02, -.012);
    group.add(shadow, logo);
    fallback.visible = false;
    canvas.dataset.wallLogoState = 'ready';
    canvas.dataset.wallLogoAspect = String(image.image.width / image.image.height);
    onChange();
  }, undefined, () => {
    if (disposed) return;
    canvas.dataset.wallLogoState = 'fallback';
    onChange();
  });

  // Geometry/materials are disposed by the scene engine's shared traversal.
  return () => { disposed = true; texture.dispose(); };
}